import { render, staticRenderFns } from "./ChatMessagePie.vue?vue&type=template&id=7d439974&scoped=true"
import script from "./ChatMessagePie.vue?vue&type=script&lang=js"
export * from "./ChatMessagePie.vue?vue&type=script&lang=js"
import style0 from "./ChatMessagePie.vue?vue&type=style&index=0&id=7d439974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d439974",
  null
  
)

export default component.exports